/**
 * Camada 0 · superficie TypeScript dos tokens.
 *
 * O VALOR das cores nao mora aqui, e nunca vai morar: ele vive em tokens.css, que e a
 * unica fonte. O que este arquivo publica e o NOME de cada token, tipado, para que quem
 * escrever `var(--cx-marka)` com erro de digitacao descubra na compilacao, e nao meses
 * depois olhando uma cor que nunca pintou.
 */

/** Todo token de cor. O prefixo --cx- e acrescentado por `tokenCor`, e nao repetido aqui. */
export const TOKENS_COR = [
  'marca',
  'marca-forte',
  'marca-suave',
  'marca-contraste',
  'superficie',
  'superficie-elevada',
  'superficie-afundada',
  'superficie-inversa',
  'texto',
  'texto-suave',
  'texto-fraco',
  'texto-inverso',
  'borda',
  'borda-forte',
  'borda-foco',
  'sucesso',
  'sucesso-suave',
  'alerta',
  'alerta-suave',
  'erro',
  'erro-suave',
  'info',
  'info-suave',
  // O "nao ha o que ler aqui": suprimido, sem classificacao, [verificar].
  'neutro',
  'neutro-suave',
  // A acao que chama um modelo, fora da escala da marca de proposito.
  'ia',
  'ia-hover',
  'ia-contraste',
  'ia-borda',
] as const;

export type TokenCor = (typeof TOKENS_COR)[number];

/** Tokens que nao sao cor: forma, ritmo e movimento. */
export const TOKENS_FORMA = [
  'espaco-1',
  'espaco-2',
  'espaco-3',
  'espaco-4',
  'espaco-5',
  'espaco-6',
  'espaco-8',
  'espaco-10',
  'espaco-12',
  'espaco-16',
  'raio-sm',
  'raio-md',
  'raio-lg',
  'raio-xl',
  'raio-full',
  'sombra-sm',
  'sombra-md',
  'sombra-lg',
  'sombra-foco',
  'alvo-toque',
  'transicao-rapida',
  'transicao-media',
] as const;

export type TokenForma = (typeof TOKENS_FORMA)[number];

/**
 * Monta a referencia a um token de cor pronta para `style`.
 *
 * O segundo argumento e a opacidade de 0 a 1. Quando ele vem, o retorno usa a sintaxe
 * de barra do CSS, que so funciona porque a cor e guardada como tres numeros e nao como
 * hex. Esse detalhe e a razao inteira do formato escolhido em tokens.css.
 */
export function tokenCor(nome: TokenCor, opacidade?: number): string {
  if (opacidade === undefined) return `rgb(var(--cx-${nome}))`;
  return `rgb(var(--cx-${nome}) / ${opacidade})`;
}

/** Monta a referencia a um token que nao e cor. */
export function tokenForma(nome: TokenForma): string {
  return `var(--cx-${nome})`;
}

/** Os dois temas que o sistema conhece. Fica aqui, e nao em @complexity/theme, porque
 *  quem define quais temas existem e a folha de tokens, que declara os valores de cada um. */
export const TEMAS = ['light', 'dark'] as const;
export type Tema = (typeof TEMAS)[number];

/** O atributo do elemento raiz que liga o tema escuro. Exportado para que nenhum
 *  componente escreva a string 'data-theme' na mao e erre por digitacao. */
export const ATRIBUTO_TEMA = 'data-theme';
